import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { ThreeDots } from "react-loader-spinner";
import crossImage from "../../images/singleinvoice/cross-red.svg";
import Delete from "../../images/icons/delete.svg";

const DeleteEventModal = ({
    deleteEventModalOpen,
    setDeleteEventModalOpen,
    selectedEvents,
    selectedEventIdForDelete,
    setSelectedEventIdForDelete,
    refetchEvents,
    setModalIsOpen,
    token,
}) => {
    const [deleteOption, setDeleteOption] = useState(null);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const handleConfirmDeleteEvent = async () => {
        if (!selectedEventIdForDelete) return;
        try {
            setIsSubmitLoading(true);
            const selectedEvent = selectedEvents.find(
                (event) => event._id === selectedEventIdForDelete
            );
            const recurringTypes = ["daily", "weekly", "monthly", "yearly"];
            const isRecurring = selectedEvent && recurringTypes.includes(selectedEvent.repeatType);

            const params = isRecurring && deleteOption ? { deleteOption } : {};
            await axios.delete(`/api/events/delete/${selectedEventIdForDelete}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            });

            global.config.activityLog(
                window.location.href,
                "Event Deletion",
                `Event ID ${selectedEventIdForDelete} deleted successfully (${isRecurring ? deleteOption : "non-recurring"})`
            );
            toast.success("Event deleted successfully", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            refetchEvents();
            setModalIsOpen(false);
            setDeleteEventModalOpen(false);
            handleCancelDeleteEvent();
            setSelectedEventIdForDelete(null);
            setDeleteOption(null);
        } catch (error) {
            console.error("Error deleting event:", error);
            global.config.slackMessage(error.toString());
            toast.error(error.response?.data?.message || "Something went wrong", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelDeleteEvent = () => {
        setDeleteEventModalOpen(false);
        setSelectedEventIdForDelete(null);
        setDeleteOption(null);
        document.body.classList.remove("ReactModal__Body--open");
    };

    const selectedEvent = selectedEvents.find((event) => event._id === selectedEventIdForDelete);
    const recurringTypes = ["daily", "weekly", "monthly", "yearly"];
    const isRecurring = selectedEvent && recurringTypes.includes(selectedEvent.repeatType);

    return (
        <Modal
            className="center-modal"
            isOpen={deleteEventModalOpen}
            onRequestClose={!isSubmitLoading ? handleCancelDeleteEvent : undefined}
            contentLabel="Confirm Delete Event"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <div className="modal-close-invite outter-modal-main">
                    <a onClick={handleCancelDeleteEvent} disabled={isSubmitLoading}>
                        <img src={crossImage} alt="Close Icon" />
                    </a>
                </div>
                <h2>{isRecurring ? "Delete this recurring event?" : "Confirm Delete"}</h2>
                {/* <p>Are you sure you want to delete this event?</p> */}
                {isRecurring ? (
                    <>
                        {/* <p>Delete this recurring event?</p> */}
                        <div className="delete-options-recuring">
                            <label className="radio-options">
                                <input
                                    type="radio"
                                    name="deleteOption"
                                    value="single"
                                    checked={deleteOption === "single"}
                                    onChange={() => setDeleteOption("single")}
                                    disabled={isSubmitLoading}
                                />
                                <span>This event only</span>
                            </label>
                            <label className="radio-options">
                                <input
                                    type="radio"
                                    name="deleteOption"
                                    value="series"
                                    checked={deleteOption === "series"}
                                    onChange={() => setDeleteOption("series")}
                                    disabled={isSubmitLoading}
                                />
                                <span>This and following events</span>
                            </label>
                        </div>
                    </>
                ) : (
                    <p>Are you sure you want to delete this event?</p>
                )}
                <div className="delete-modal-buttons">
                    <button
                        onClick={handleConfirmDeleteEvent}
                        disabled={isSubmitLoading || (isRecurring && !deleteOption)}
                        className="modal-btn modal-btn-calendar delete"
                    >
                        {isSubmitLoading ? (
                            <ThreeDots
                                height="18"
                                width="20"
                                radius="9"
                                color="#2563eb"
                                ariaLabel="three-dots-loading"
                                visible={true}
                            />
                        ) : (
                            <>
                                Delete
                                <img src={Delete} alt="Delete" />
                            </>
                        )}
                    </button>
                    <button
                        onClick={handleCancelDeleteEvent}
                        disabled={isSubmitLoading}
                        className="modal-btn modal-btn-calendar cancel"
                    >
                        Cancel
                    </button>
                </div>

            </div>
        </Modal >
    );
};

export default DeleteEventModal;